module.exports = __webpack_public_path__ + "static/media/TUSA-Multicultural-tile-453x453.45dde0a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutus/TUSA-Multicultural-tile-453x453.jpg
// module id = 306
// module chunks = 0